import React, { useEffect, useState } from 'react';
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { apiCheckAccount, apiGetSetting } from "../../services/api.service.js";

function SearchUser() {
  const [userName, setUserName] = useState("");
  const [webSetting, setWebSetting] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        let result = await apiGetSetting();
        if (result && result.status_code === 200 && result.data) {
          setWebSetting(result.data);
        }
      } catch (error) {
        return Swal.fire({ icon: "error", text: "Lỗi kết nối, vui lòng liên hệ CSKH để được hỗ trợ." });
      }
    };
    fetchData();
  }, []);

  const checkUser = async () => {
    if (!userName) {
      return Swal.fire({ icon: "error", text: "Vui lòng nhập tên tài khoản." });
    } else {
      let result = await apiCheckAccount(userName);
      if (result && result?.code === 200) {
        let data = result.data;
        navigate("/profile", { state: { userName, data, webSetting } });
      }
    }
  };

  return (
    <div
      className="relative w-full md:max-w-[640px] sm:max-w-[480px] max-w-full md:px-10 px-3 md:pb-10 pb-5 mb-10
      mx-auto rounded-[24px] border border-[1.5px] border-[#FEF1E9] bg-gradient-to-b from-white to-[#FFEBDD] 
      shadow-[0_0_0_4px_rgba(255,228,207,0.60),0_12px_75.3px_20px_rgba(255,255,255,0.80),-4px_-4px_10px_0_rgba(255,255,255,0.40)] tracking-wide"
    >
      <div className='w-full h-fit flex justify-center items-center'>
        <img src="/search/title-sup-cskh.png" alt="logo" className='w-full md:max-w-[300px] max-w-[200px] h-auto object-contain' />
      </div>
      <p className="md:text-[16px] text-[14px] font-bold text-[#f27121] tracking-wide text-center">VUI LÒNG XÁC NHẬN TÀI KHOẢN CỦA BẠN</p>
      <div className="mt-[15px] flex items-center gap-2 relative">
        <div className="h-12 flex items-center justify-between rounded-[7px] pl-12 pr-3 border border-[#f58d4d] relative w-full bg-white box-border">
          <img className="absolute left-4 w-5 h-5"
            style={{ filter: 'invert(63%) sepia(93%) saturate(634%) hue-rotate(340deg) brightness(101%) contrast(96%)' }}
            alt="icon-search"
            src="/icons/icon-search.png" />
          <input className="border-none outline-none bg-transparent text-[#8e8e8e] text-base h-full w-full italic placeholder:italic"
            onChange={(e) => setUserName(e.target.value.toLowerCase().trim())}
            type="text"
            placeholder="Nhập tên đăng nhập"
          />
        </div>
        <button
          className="h-12 px-4 py-2.5 flex items-center justify-center uppercase text-white text-[14px] md:text-[16px] font-inter font-semibold tracking-wide border-2 border-white rounded-[12px] w-fit cursor-pointer whitespace-nowrap text-center"
          style={{
            background: "radial-gradient(127.18% 129.6% at 16.46% 16.82%, rgba(255,255,255,0.41) 0%, rgba(255,255,255,0.00) 69.79%, rgba(255,255,255,0.00) 100%), var(--colors-Primary-500, #F27121)",
            boxShadow: "2px 4px 8px 0 rgba(255,255,255,0.60) inset, -3px -6px 11px 0 rgba(255,233,215,0.25) inset"
          }}
          onClick={checkUser}
        >
          KIỂM TRA
        </button>
      </div>
      <div className="mt-5 text-center">
        <div className="mt-[30px] rounded-[10px] border-2 border-[#DCDFE3] bg-cover p-[10px_15px] relative">
          {webSetting && webSetting.login_info_notice ? (
            <div className="[&>p]:font-medium [&>p]:text-base [&>p]:leading-[150%] [&>p]:text-justify [&>p]:text-[#36a638]"
              dangerouslySetInnerHTML={{ __html: webSetting.login_info_notice }} />
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default SearchUser;
